import { addLoadedItemReadingPaneViewState } from '../mutators/loadedItemViewStateMutators';
import ItemReadingPaneViewState from '../store/schema/ItemReadingPaneViewState';
import readingPaneStore from '../store/Store';
import { isFeatureEnabled } from 'owa-feature-flags';
import { action } from 'satcheljs/lib/legacy';

export default action('setItemReadingPaneViewState')(function setItemReadingPaneViewState(
    viewState: ItemReadingPaneViewState
) {
    if (isFeatureEnabled('rp-persistedReadingPaneTabs')) {
        addLoadedItemReadingPaneViewState(viewState);
    } else {
        readingPaneStore.itemReadingPaneViewState = viewState;
    }
});
